import { c as _c } from "react/compiler-runtime";
import { Logo } from "@/components/Logo";
import { PrivacyBadge, ServerBadge } from "@/components/PrivacyBadge";
const navLink = "inline-flex min-h-11 items-center rounded-lg px-3.5 font-medium text-ink hover:bg-sand";

/** `home`: logo + main nav. `tool`: compact bar with the privacy badge
 *  ("Uses our server" on server tools). */
export function SiteHeader(t0) {
  const $ = _c(5);
  const {
    variant: t1,
    server: t2
  } = t0;
  const variant = t1 === undefined ? "home" : t1;
  const server = t2 === undefined ? false : t2;
  if (variant === "tool") {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Logo size="sm" />;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] !== server) {
      t4 = <header className="border-b bg-canvas"><div className="mx-auto flex max-w-[1320px] flex-wrap items-center justify-between gap-3 px-4 py-2 sm:px-6">{t3}{server ? <ServerBadge /> : <PrivacyBadge />}</div></header>;
      $[1] = server;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Logo />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <header className="mx-auto flex w-full max-w-[1200px] flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-4 sm:px-6 sm:py-5">{t3}<nav aria-label="Main" className="-mx-3.5 flex flex-wrap items-center gap-1 sm:mx-0 sm:gap-2"><a href="/#pdf-tools" className={navLink}>PDF tools</a><a href="/#image-tools" className={navLink}>Image tools</a><a href="/#privacy" className={navLink}>Privacy</a><a href="/#tools" className="inline-flex min-h-11 items-center rounded-lg border-[1.5px] border-ink px-4 font-semibold text-ink hover:bg-sand">All tools</a></nav></header>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}